
import { Component } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';

declare const $: any;

@Component({
    selector: "loading",
    template: ``
})

export class LoadingComponent extends SiriusBaseComponent<any> { 

    constructor() {
        super(); 
    }
    
    OnInit() { 
         
        this.dataService.onProgressStarted = function () {
                $('html').block({
                    message: "<div  class='custom-loading'></div>",
                    overlayCSS: {
                        backgroundColor: '#fff',
                        opacity: 0.5,
                        cursor: 'default',
                        zIndex: 30010
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor:
                        'transparent',
                        cursor: 'default',
                        zIndex: 30010
                    }
                });
            
        };

        this.dataService.onProgressCompleted = function () {
            $('html').unblock();
        };



       
    }
}
